import { render, staticRenderFns } from "./RoleDrawer.vue?vue&type=template&id=79ab273b"
import script from "./RoleDrawer.vue?vue&type=script&lang=js"
export * from "./RoleDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports